import 'css-chunksrc/feature/modifier/ModifierButton.module.scss';export default {
  "root": "ModifierButton_root",
  "pulse": "ModifierButton_pulse",
  "name": "ModifierButton_name",
  "selection_label": "ModifierButton_selection_label",
  "selections": "ModifierButton_selections",
  "required": "ModifierButton_required",
  "invalid": "ModifierButton_invalid",
  "selected": "ModifierButton_selected"
};